const zh = {

    // 菜单
    "menu": [
            {
                id: "1",
                "name": 'HOME',
            },
            {
                id: "2",
                "name": 'SERVICES',
                "subName": [
                    {
                        id: "2-1",
                        name: "WAREHOUSING" 
                    },{
                        id: "2-2",
                        name: "DIVERSIFIED TRANSPORTATION SERVICES"
                    },{
                        id: "2-3",
                        name: "FORWARDING"
                    },{
                        id: "2-4",
                        name: "VALUE-ADDED SERVICES"
                    },{
                        id: "2-5",
                        name: "CHEMICAL SUPPLY CHAIN SOLUTIONS"
                    },{
                        id: "",
                        name: "MORE"
                    }
                ]
            },
            {
                id: "3",
                name: 'INDUSTRIES',
                "subName": [
                    {
                        id: "3-1",
                        name: "MATERIAL SCIENCE"
                    },{ 
                        id: "3-2",
                        name: "PAINTS & COATINGS"
                    },{
                        id: "3-3",
                        name: "LUBRICATING OIL"
                    },{
                        id: "3-4",
                        name: "AGROCHEMICAL"
                    },{
                        id: "3-5",
                        name: "ELECTRONIC CHEMICALS"
                    },{
                        id: "3-6",
                        name: "NEW ENERGY"
                    },{
                        id: "3-7",
                        name: "CHEMICAL REAGENT"
                    },{
                        id: "3-8",
                        name: "MORE"
                    }
                ]
            },
            {
                id: "4",
                name: 'NETWORK',
                "subName": [
                    {
                        id: "4-1",
                        name: "EAST CHINA"
                    },{
                        id: "4-2",
                        name: "NORTH CHINA"
                    },{
                        id: "4-3",
                        name: "SOUTHWEST CHINA"
                    }
                    ,{
                        id: "4-4",
                        name: "SOUTH CHINA"
                    }
                ]
            },
            {
                id: "5",
                name: 'IT',
                'subName': [
                    {
                        id: "5-1",
                        name: "WAREHOUSING INFORMATION VISUALIZATION"
                    },{
                        id: "5-2",
                        name: "REMOTE TRANSPORTATION VISUALIZATION"
                    },{
                        id: "5-3",
                        name: "HSSEQ COPYRIGHTED MANAGEMENT SOFTWARE"
                    },{
                        id: "5-4",
                        name: "EDI INTERFACE"
                    }
                ]
            },
            {
                id: "6",
                name: 'HSSEQ',
                "subName": [
                    {
                        id: "6-1",
                        name: "HSSEQ BUILDING MILESTONES"
                    },{
                        id: "6-2",
                        name: "OBJECTIVES & PURPOSES"
                    },{
                        id: "6-3",
                        name: "DIGITAL AND INTELLIGENT APPLICATIONS"
                    },{
                        id: "6-4",
                        name: "PERSONALIZATION"
                    },{
                        id: "6-5",
                        name: "FEATURED SHOWCASE"
                    }
                ]
            },
            {
                id: "7",
                name: 'ABOUT US',
                "subName": [
                    {
                        id: "7-1",
                        name: "PHILOSOPHY"
                    },{
                        id: "7-2",
                        name: "ACCREDITATIONS & AWARDS"
                    },{
                        id: "7-3",
                        name: "SUSTAINABILITY"
                    },{
                        id: "7-4",
                        name: "CONTACTS"
                    }
                    // ,{
                    //     id: "7-5",
                    //     name: "合作伙伴"
                    // }
                ]
            },
            {
                id: "8",
                name: 'PRESS',
                "subName": [
                    {
                        id: "8-1",
                        name: "PRESS RELEASE"
                    },{
                        id: "8-2",
                        name: "KLN NEWS"
                    }
                    // ,{
                    //     id: "8-3",
                    //     name: "媒体报道"
                    // }
                ]
            },
            {
                id: "9",
                name: 'K-PORTAL'
            }
    ],
    //登录
    "login": {
        "placeholder1": "account number",
        "placeholder2": "password",
        "login": "login"
    },
    "footer": {
        "focus": "Follow Us",
        "member": "A member of",
        "company": "嘉里化工物流有限公司",
        "link1": "DISCLAIMER",
        "link2": "LEGAL",
        "link3": "POLICY STATEMENTS",
        "link4": "Internal Login",
        "link5": "Related Links",
        "link6": "Kerry Logistics",
        "link7": "Kerry Logistics Network",
        "link8": "JiaHui Express",
        "copyright": "版权所有"
    },
    // 首页
    "index": {
        "title": ["ASIA-BASED", "GLOBAL", "SOLUTIONS"],
        "products": {
            "title": "SERVICES",
            "actions": [
                {
                    "name": "Warehousing",
                },{
                    "name": "DIVERSIFIED TRANSPORTATION SERVICES",
                },{
                    "name": "FORWARDING",
                },{
                    "name": "VALUE-ADDED SERVICES",
                },{
                    "name": "CHEMICAL SUPPLY CHAIN SOLUTIONS",
                },{
                    "name": "MORE",
                }
            ]
        },
        "industries": {
            "title": "INDUSTRIES",
            "actions": [
                {
                    "name": "MATERIAL SCIENCE",
                },{
                    "name": "PAINTS & COATINGS",
                },{
                    "name": "LUBRICATING OIL",
                },{
                    "name": "AGROCHEMICAL",
                },{
                    "name": "ELECTRONIC CHEMICALS",
                },{
                    "name": "NEW ENERGY",
                },{
                    "name": "CHEMICAL REAGENT ",
                },{
                    "name": "MORE",
                }
            ]
        },
        "about": {
            "title": "YOUR PROFESSIONAL PARTNER FOR CHEMICAL LOGISTICS",
            "content1": "KLN IMS Logistics is one of the essential business segments of KLN. We combine the two core operations of integrated logistics and international freight forwarding in the supply chain to provide a total solution in the chemical logistics industry.  ",
            "content2": "Our services focus on seven vertical markets of paints and coatings, material science, lubricating oils, agrochemical, electronic chemicals, new energy resources, and chemical reagents.",
            "content3": 'KLN',
            "content4": 'Kerry Logistics',
            "content5": "Our systematic management includes the whole system certification based on HSSEQ, and we have won many awards in related fields, which makes us a significant member of an authoritative organization in the domestic chemical logistics industry.",
            "more": "Learn more",
            "hideMore": "Hide more",
        },
        "globalNet": {
            "title": "NETWORK",
            "content": "Kerry IMS Chemical Logistics is a leading national third-party logistics service provider with a nationwide network.",
            "net": [
                {
                    "id": 1,
                    "name": "East China",
                    "company": [
                        "KERRY IMS CHEMICAL STORAGE & TRANSPORT (SHANGHAI) CO., LTD.",
                        "FENGCHENG HUICHENG CHEMICAL LOGISTICS CO., LTD.", 
                        "KERRY CHEMICAL LOGISTICS (ZHANGJIAGANG) CO., LTD."
                    ]
                },{
                    "id": 2,
                    "name": "North China",
                    "company": [
                        "KERRY LANHAI (TIANJIN) LOGISTICS CO., LTD.",
                        "KERRY IMS CHEMICAL LOGISTICS (CANGZHOU) CO., LTD.", 
                    ]
                },{
                    "id": 3,
                    "name": "Southwest China",
                    "company": [
                        "KERRY CHEMICAL LOGISTICS (CHENGDU) CO., LTD."
                    ]
                }
                ,{
                    "id": 4,
                    "name": "South China",
                    "company": []
                }
            ],
            "more": "Learn more",
        },

        "technology": {
            "title": "IT",
            "content": "Investing in technological innovation and application is our long-term strategy.",
            "content1": "Technological innovation needs to realize safety, standardization, and efficiency in operation management.",
            "content2": "Warehousing Information Visualization",
            "content3": "Remote Transportation Visualization",
            "content4": "HSSEQ Copyrighted Management Software",
            // "function": ['全球定位追踪','自主研发App','物流诊断 数据分析','物联网及射频识别技术','供应链控制中心BI','自动存储搬运设施','可穿戴科技语音识别','数据对接平台','全方位物流管理方案'],
            "more": "Learn more"
        },

        "security": {
            "title": "HSSEQ",
            "content": "Our company has formed a relatively complete document system after nearly 20 years of developing the HSSEQ management system. From groping and establishing per international standards to forming a document structure of the quality, environment, and safety management system in line with the company's operating characteristics, also, from the strategic policies issued by the top management to the operation protocol for the grassroots level, the HSSEQ management systems at all levels ensure each customer's service quality and safety.",
            "more": "Learn more"
        },

        "function": [
            "PRESS", "CAREERS", "STAFF LOGIN"
        ]
    },
    //专业服务
    "services": {
        "title": "SERVICES",
        "function": [
            {
                "name": "WAREHOUSING",
                "subName": ["NON-DG Warehouses", "DG Warehouses", "Storage Tank"]
            },{
                "name": "DIVERSIFIED TRANSPORTATION SERVICES",
                "subName": ["Domestic", "International", "Multimodal Transportation"]
            },{
                "name": "FORWARDING",
                "subName": []
            }
            ,{
                "name": "VALUE-ADDED SERVICES",
                "subName": []
            }
            ,{
                "name": "CHEMICAL SUPPLY CHAIN SOLUTIONS",
                "subName": ["Supply Chain Trading"]
            }
        ]
    },
    //行业解决方案
    "industries": {
        "title": "INDUSTRIES",
        "function": [
            {
                "name": "MATERIAL SCIENCE",
                "subName": []
            },{
                "name": "PAINTS & COATINGS",
                "subName": []
            },{
                "name": "LUBRICATING OIL",
                "subName": []
            }
            ,{
                "name": "AGROCHEMICAL",
                "subName": []
            },{
                "name": "ELECTRONIC CHEMICALS",
                "subName": []
            },{
                "name": "NEW ENERGY",
                "subName": []
            },{
                "name": "CHEMICAL REAGENT ",
                "subName": []
            },{
                "name": "MORE",
                "subName": []
            }
        ]
    },
    //全国网络
    "globalNet": {
        "title": "NETWORK",
        "function": [
            {
                "name": "EAST CHINA",
                "componey": [{
                    "conpanyName": "KERRY IMS CHEMICAL STORAGE & TRANSPORT (SHANGHAI) CO., LTD.",
                    "address1": "388, Shengrong Road, Building 23, Pudong New District, Shanghai, China",
                    "address2": "",
                    "phone": "021-51386111",
                    "mail": "presiden.office@kerryhcl.com"
                },{
                    "conpanyName": "FENGCHENG HUICHENG CHEMICAL LOGISTICS CO., LTD.",
                    "address1": "Room 102, Unit 2, Building 2, Changlong Jiangnan Mingju, Fengcheng City, Jiangxi Province, China",
                    "address2": "",
                    "phone": "0795-6598466",
                    "mail": "presiden.office@kerryhcl.com"
                },{
                    "conpanyName": "KERRY CHEMICAL LOGISTICS (ZHANGJIAGANG) CO., LTD.",
                    "address1": "Room 308-1166, International Consumer Goods Center Building, Beijing Road, Zhangjiagang Bonded Zone, Zhangjiagang City, Jiangsu Province, China",
                    "address2": "",
                    "phone": "0512-56720219",
                    "mail": "Hui.Cai@kerryeas.com"
                },{
                    "conpanyName": "JIAHUI LOGISTICS (ZHANGJIAGANG) CO., LTD.",
                    "address1": "Room 102-103, Building 1, East Zone, Zhangjiagang Bonded Logistics Park, Zhangjiagang City, Jiangsu Province, China",
                    "address2": "",
                    "phone": "",
                    "mail": ""
                }]
                
            },{
                "name": "NORTH CHINA",
                "componey": [{
                    "conpanyName": "KERRY LANHAI (TIANJIN) LOGISTICS CO., LTD. ",
                    "address1": "No. 39, Jingli Road, Beichen Science Park South District, Beichen District, Tianjin, China",
                    "address2": "",
                    "phone": "022-86825688",
                    "mail": "wangyihua@lanhai56.cn"
                },{
                    "conpanyName": "KERRY IMS CHEMICAL LOGISTICS (CANGZHOU) CO., LTD.",
                    "address1": "Zhongjie Lingang Chemical Park, Cangzhou City, Hebei Province, China",
                    "address2": "",
                    "phone": "0317-5837376",
                    "mail": "presiden.office@kerryhcl.com"
                }]
            },{
                "name": "SOUTHWEST CHINA",
                "componey": [{
                    "conpanyName": "KERRY CHEMICAL LOGISTICS (CHENGDU) CO., LTD.",
                    "address1": "2F Office Building, No. 9, Longhong Road, Hong'an Town, Longquanyi District, Chengdu, Sichuan, China",
                    "address2": "",
                    "phone": "028-62046133",
                    "mail": "wangyihua@lanhai56.cn"
                }]
            },{
                "name": "SOUTH CHINA",
            }
        ]
    },
    //尖端科技
    "technology": {
        "title": "IT",
        "function": [
            {
                "name": "WAREHOUSING INFORMATION VISUALIZATION",
                "subName": []
            }, {
                "name": "REMOTE TRANSPORTATION VISUALIZATION",
                "subName": []
            }, {
                "name": "HSSEQ COPYRIGHTED MANAGEMENT SOFTWARE",
                "subName": ["MSDS Cloud System", "Vehicle Inspection System", "Warehouse Safety Routine Inspection Cloud Management System", "NCM Management Cloud System", "EDI INTERFACE"]
            }
        ]
    },

    //HSSEQ管理体系
    "security": {
        "title": "HSSEQ",
        "function": [{
            "name": "HSSEQ BUILDING MILESTONES"
        },{
            "name": "OBJECTIVES & PURPOSES"
        },{
            "name": "DIGITAL AND INTELLIGENT APPLICATIONS"
        },{
            "name": "PERSONALIZATION"
        },{
            "name": "FEATURED SHOWCASE"
        }]
    },

    //关于我们
    "about": {
        "title": "ABOUT US",
        "function": [{
            "name": "PHILOSOPHY"
        },{
            "name": "ACCREDITATIONS & AWARDS",
            "subName": ["Accreditations","Awards"]
        },{
            "name": "SUSTAINABILITY",
            // "subName": ["环境保护","公益"]
        },{
            "name": "CONTACTS"
        }
        // ,{
        //     "name": "合作伙伴"
        // }
    ]
    },

    //新闻中心
    "news": {
        "title": "PRESS",
        "function": [{
            "name": "PRESS RELEASE"
        },{
            "name": "KLN NEWS"
        }
    ]
    },
    // kportal
    "kportal": {
        "title": "K-PORTAL",
        "content1": {
            "title": "Customer  Login",
            "urls": [{"name":"T&T","url":"https://hckapp.kerryims.com/T&T/"}, {"name":"Data Insight","url":"https://insight.kerryims.com/webroot/decision"}]
        },
        "content2": {
            "title": "Supplier Login",
            "urls": [{"name":"Supplier Service System","url":"http://118.242.1.226:83/hcwl/vender/Login.aspx"},{"name":"Vehicle Booking System","url":"https://apps.kerryims.com:82/221/#/dispatcherAdmin-appointment"}]
        },
    },

    //合作伙伴
    "partners": {
        "title": "合作伙伴",
        "function": [{
            "name": "行业伙伴"
        },{
            "name": "供应商"
        }]
    },

    //加入嘉里
    "join": {
        "title": "CAREERS",
        "function": [{
            "name": "WORKING AT KERRY LOGISTICS"
        },{
            "name": "JOB OPPORTUNITIES"
        }]
    },

    // 员工登录
    "staffLogin": {
        "title": "Staff Login",
        "urls": [{
            "title": "Marketing",
            "contents": [{"name": "CRM System", "url":"https://crm-tencent.xiaoshouyi.com"}]
        },{
            "title": "Business Operations",
            "contents": [
                {"name": "TMS", "url":"https://tms.kerryims.com/login"},
                {"name": "Transportation Contower", "url":"https://hckapp.kerryims.com/contower/"},
                {"name": "Vehicle Booking System", "url":"https://apps.kerryims.com:82/221/#/warehouse/login"},
                {"name": "NCM", "url":"https://hckapp.kerryims.com/ncm/ncmweb/views/login/login.jsp"},
                {"name": "Vehicle Security Check System", "url":"https://hckapp.kerryims.com/kscweb/login.jsp"},
                {"name": "Warehouse Security Check System", "url":"https://hckapp.kerryims.com/checkweb/index.jsp"},
                {"name": "MSDS", "url":"https://hckapp.kerryims.com/msds/segments/login/login.jsp"}
            ]
        },{
            "title": "Logistical Support",
            "contents": [
                {"name": "Cloud-Hub", "url":"https://yunzhijia.com/home/saas/jlwl"},
                {"name": "Financial Management System", "url":"https://kerry.kdcloud.com/index.html?&formId=pc_main_console"},
                {"name": "Human Resource Management", "url":"https://kerry.kdeascloud.com/shr/home.do"},
                {"name": "Email", "url":"http://mail.kerryims.com/"},
                // {"name": "Netdisk", "url":"http://intranet.kerryims.com:8000/default.aspx"},
                {"name": "Cloud Drive", "url":"https://shimo.im/loginByPassword?from=home"},
                {"name": "Graphite Files", "url":"https://shimo.im/loginByPassword"},
            ]
        },{
            "title": "Data Insights",
            "contents": [{"name": "BI System", "url":"https://insight.kerryims.com/webroot/decision"}]
        }]
    },

    //组件普通（危险）化学品仓库
    "warehouse1": {
        "content":"Following the strategic layout of Kerry IMS's primary chemical industry, we have been actively developing and constructing chemical logistics centers in North China, East China, South China, and Western China, achieving simultaneous shipments from warehouses in all major regions across the country.",
        "title1": "NON-DG WAREHOUSES",
        "title2": "DG WAREHOUSES"
    },

    //组件储罐
    "warehouse2": {
        "content":"The delivery platform of the liquid storage tank area has a total of 60 canning slots. The total length of the canning line is about 270 meters. Dangerous chemical can be store and transit such as ketones, alcohols, esters, benzenes, solvent oils, alkanes."
    },
    //组件多样化运输方案Index
    "diversifiedtransportIndex": {
        "content": "With our vast network and the strong support of the Kerry Logistics network, we can provide customers with a full range of chemical logistics solutions from domestic to overseas and multimodal transportation. "
    },
    // 组件多样化运输方案
    "diversifiedtransport": [
        {
            "name": "DOMESTIC",
            "content1": "Road Transportation, Domestic Shipping, Railway Container, Special Railway Line",
            "content2": "Our road transportation network covers major cities in China, providing end-to-end service to customers.",
            "content3": "We have a high-standard dangerous goods fleet, professionally assessed by CRSAS. We possess ample self-owned vehicles and a vast outsourcing fleet, including vans, flatbed trailers, dangerous goods, refrigerated insulation vehicles. Most of the cars are equipped with GPS devices.",
            "content4": "Chemical transportation protection, emergency rescue services, and transport visualization are realized on our platform.",
            "content5": "We provide diversified road transportation services such as full truck, LTL, temperature control, and customs supervision.",
            "content6": "Our scientific transportation modes, such as swap trailer transport and multimodal transportation, continue to save logistics costs for customers. ",
            // "content7": "我们的",
            "content8": "Transportation License Covering",
            "content9": "Type 2: Gas",
            "content10": "Type 3: Flammable Liquid",
            "content11": "Type 4: Flammable Solids, Substances Liable to Spontaneous Combustion, Substances that emit flammable gas in contact with water",
            "content12": "Type 5: Oxidizing Substances and Organic peroxides",
            "content13": "Type 6: Toxic and Infectious substances",
            "content14": "Type 8: Corrosive Substances",
            "content15": "Type 9: Miscellaneous hazardous substances and articles, including environmentally hazardous substances"
        },{
            "content1": "Air And Sea Shipping, Customs Clearance, China-European Railway Express, Cross-Border Road Transportation",
            "content2": "Under the continuous influence of the pandemic, the advantages of rail freight's convenience of customs clearance and low cost become more and more apparent. Especially the China-Europe Railway Express, under the circumstances of poor international air and sea shipping and the rising price, opens a new path for domestic enterprises to exploit the global market and becomes a new channel for import and export. Kerry Logistics Network currently has the most robust network in Asia, from South Korea, across Central Asia to Turkey, from east to west,  covering 30 countries and regions, and connects a vast land and rail freight network.",
            "title1": "Global Freight Forwarding Capabilities",
            "list1": [
                {
                    "text1": "AIR & SEA"
                },
                {
                    "text1": "520,000+",
                    "text2": "tons of air freight annually"
                },
                {
                    "text1": "1.2 million +",
                    "text2": "TEUs of ocean freight annually",
                    // "text3": "(20呎标准货柜)"
                },
                {
                    "text1": "ROAD",
                },
                {
                    "text1": "5,200+",
                    "text2": "trucks on the road every day"
                },
                {
                    "text1": "280+",
                    "text2": "road freight terminals across Asia"
                },
                {
                    "text1": "RAIL",
                },
                {
                    "text1": "117,000+",
                    "text2": "containers annually"
                },
                {
                    "text1": "1,900+",
                    "text2": "rail freight terminals across Eurasia"
                }
            ],
            "title2": "Comprehensive Freight Solution",
            "list2": {
                "item1": ["FCL / LCL","Buyer's consoles","Multimodal Transportation","General/Special cargo","Charter","GSA / GSSA","Customs Brokerage","NVOCC"],
                "item2": ["FCL / LCL","Low loader / Flatbed Trailer","Reefer / DG cargo","Bonded trucking","Project Cargo","ISO tank","Container / Open-top truck","Car carrier"],
                "item3": ["FCL / LCL","Block Train","Multimodal Transportation","Project Cargo","Break-bulk","Bulk Cargo","Buyer's consoles"]
            }
        },{
            "content1": `By 2021, the China-European Railway Express "Kerry" starts from Chengdu Container Center Station, exits through the Alataw Port, and heads to Europe. It passes through Malasevic, Poland, and arrives in Duisburg, Germany. This project is essential for Kerry Logistics to take the "Belt and Road" as its development program. It is also a strategic move to expand rail freight and multimodal transport services.`,
            "content2": "Relying on KLN's most robust network in Asia, since 2016, we have successively opened China-Europe and Central Asia international freight trains in Gansu, Ningxia, Shanxi, Xuzhou, Chengdu, and other places, and launched 500 international trains every year. Also, we provide customers with multimodal transportation of bulk raw materials and diversified equipment such as containers, ISO TANK, covering domestic low-cost logistics solutions of river, sea, and rail."
        }
    ],

    //组件国际货代
    "internationalFreight": [
        {
            "content1": "KLN's global freight solutions cover international air, sea, road, rail, and multimodal services. KLN handled over 520,000 tons of air freight and 1.2 million TEUs of ocean freight in 2021. KLN has 5,200+ trucks on the road every day and over 280 road freight terminals across Asia. In rail freight, KLN handles 117,000+ containers annually and overs 1,900 rail freight terminals across Eurasia. KLN has extensive experience in handling trade disputes, quotations, customs clearance, and quarantine procedures and can respond to changes in trade policies and emergencies in real-time to ensure that our customers' international shipments are optimally cost-effective.",
            "title1": "Global Freight Forwarding Capabilities",
            "list1": [
                {
                    "text1": "AIR & SEA"
                },
                {
                    "text1": "520,000+",
                    "text2": "tons of air freight annually"
                },
                {
                    "text1": "1.2 million +",
                    "text2": "TEUs of ocean freight annually",
                    // "text3": "(20呎标准货柜)"
                },
                {
                    "text1": "ROAD",
                },
                {
                    "text1": "5,200+",
                    "text2": "trucks on the road every day"
                },
                {
                    "text1": "280+",
                    "text2": "road freight terminals across Asia"
                },
                {
                    "text1": "RAIL",
                },
                {
                    "text1": "117,000+",
                    "text2": "containers annually"
                },
                {
                    "text1": "1,900+",
                    "text2": "rail freight terminals across Eurasia"
                }
            ],
            "title2": "Comprehensive Freight Solution",
            "list2": {
                "item1": ["FCL / LCL","Buyer's consoles","Multimodal Transportation","General/Special cargo","Charter","GSA / GSSA","Customs Brokerage","NVOCC"],
                "item2": ["FCL / LCL","Low loader / Flatbed Trailer","Reefer / DG cargo","Bonded trucking","Project Cargo","ISO tank","Container / Open-top truck","Car carrier"],
                "item3": ["FCL / LCL","Block Train","Multimodal Transportation","Project Cargo","Break-bulk","Bulk Cargo","Buyer's consoles"]
            }
        }
    ],

    //组件增值服务
    "valueAdded": {
        "content": "Combined with our integrated logistics solutions, we offer customers a wide range of value-added services. By outsourcing the procedures of sub-packaging, limited packaging, secondary packaging, sample management, and color mixing services to Kerry IMS Chemical Logistics, you can focus on your core business of sales, R&D, and customer service. ",
        "list": [
            {
                "title": "MATERIAL SCIENCE",
                "content1": "On-site Logistics & System",
                "content2": "RDC Fulfilment",
                "content3": "B-b-C SCM Network & B-b-C Inventory",
            },
            {
                "title": "PAINTS & COATINGS",
                "content1": "Driving Behavior",
                "content2": "Frostbite Prevention",
                "content3": "Color Mixture",
            },
            {
                "title": "LUBRICATING OILS",
                "content1": "C1 Warehousing",
                "content2": "Sub-packaging",
                "content3": "Seasonal Burst",
            },
            {
                "title": "AGROCHEMICAL",
                "content1": "Limited Packaging",
                "content2": "Road Risk",
                "content3": "EDI",
            },
            {
                "title": "ELECTRONIC CHEMICALS",
                "content1": "Inbound/VMI",
                "content2": "Dangerous Gas",
                "content3": "Serial Number Management",
            },
            {
                "title": "NEW ENERGY RESOURCES",
                "content1": "DG Temperature Control",
                "content2": "Milkrun After-sales Logistics",
                "content3": "Package Management",
            },
            {
                "title": "CHEMICAL REAGENT",
                "content1": "Secondary Packaging",
                "content2": "Sample Management",
                "content3": "MSDS Cloud System",
            },
        ]
    },

    //组件供应链解决方案
    "supplyChain": {
        "content1": "The chemical supply chain is becoming increasingly complex and multifaceted. We provide highly tailored solutions to meet your unique needs to support your procurement, production, and distribution activities in multiple countries.",
        "content2": "Our professional account management team continues to design new business models and solutions for our international customers, from consulting, design, to execution and evaluation, which can reduce inventory, shorten the time for goods to be launched to the market and significantly save costs.",
        "content3": "Through long-term partnerships, competitive cost management, and continuous improvement, we are committed to helping you achieve global, regional, and local strategic goals. "
    },

    //组件运贸一体化
    "integrationTransportation": [
        {
            "title": "Based on credit evaluation & logistics supervision, we focus on the core firms' entire supply chain, providing them and their upstream and downstream a complete set of trade and logistics solutions.",
            "year": "YEAR ",
            "word1": "Coal",
            "word2": "Steel",
            "word3": "Chemical",
            "word4": "Construction Materials(Sand, Cement)",
            "ton": "(Ton)"
        }
    ],

    //组件应用材料
    "appliedMaterials": {
        "title1": "On-site",
        "title2": "RDC",
        "content1": "Following the high standards of industry norms, we escort the supply chain logistics compliance of internationally renowned companies and provide customers with professional warehousing services, including general cargo, dangerous goods, and special needs such as bonded operation and temperature control. In addition, we offer general cargo and transportation of hazardous goods services originating from ports and factories. We also give customized solutions such as stock transfer, distribution, free trade zone pickup, and delivery, reverse logistics, covering overall logistics solutions for the entire industry supply chain. Even more, we have on-site warehousing outsourcing services for customers.",
        "content2": "We provide customers on-site warehousing outsourcing services, including labor, systems, inventory design, and TCM services.",
        "content3": "Relying on KLN global strategic cooperation system, we provide logistics solutions, standardized procedures, and process control for the entire industry chain."
    },

    //组件油漆涂料
    "paintCoating": {
        "content1": "Our nationwide transportation service network has cost-effective transportation routes and excellent chemical dangerous goods operation capabilities. Our dangerous goods vehicle transportation is equipped with digital and intelligent equipment such as vehicle and cargo tracking system, GPS, and online Website tracking system.",
        "title1": "Instant Delivery",
        "content2": "We offer 7×8 hours delivery service, some 7x24 service if necessary. We can meet the notification time for 1-2 hours delivery and provide resident vehicles and a delivery coordinator if needed.",
        "title2": "Value-added Services",
        "content3": "We provide additional services such as labeling /relabelling, paneling, reinforcement. ",
        "title3": "Hazardous Waste Disposal",
        "content4": "We offer recycling packaging services.",
        "title4": "Winter Insulated Transport",
        "content5": "We provide transportation operation programs for special transportation temperature requirements; to meet unique needs for vehicle conditions."
    },

    //组件润滑油
    "lubricatingOil": {
        "content": "For the characteristics of the lubricant industry, we provide a full range of supply chain logistics solutions from raw material import, RDC management to transportation and warehousing and provide customized services such as special packaging and unloading according to customer needs.",
        "title1": "Finished Products and Raw Materials Import",
        "content1": "We provide import customs declaration, inspection,import trailer transportation, and other services for finished lubricating oils and raw materials.",
        "title2": "Domestic RDC Management",
        "content2": "Specific to the characteristics of lubricant products, we carry out the site selection, renovation, and daily operation of RDC (C1 Warehouse).",
        "title3": "Domestic Transportation",
        "content3": "Multimodal transportation, OEM particular vehicle distribution, milkrun, and other daily distribution.",
        "title4": "Reverse Logistics",
        "content4": "Reverse transportation operation of lubricating oil products.",
        "title5": "Special Container Packaging",
        "content5": "According to the different needs of customers, we provide a variety of packaging container solutions, FIBC.",
        "title6": "Warehouse and Distribution Informatization",
        "content6": "We provide customer visualized information of warehouse, transportation, and distribution.",
        "title7": "Unloading Service",
        "content7": "For customers who need to provide unloading services at the receiving end, we carry portable lifting equipment with the vehicle to ensure the safety of the goods while ensuring the efficiency of unloading and reducing the occurrence of damage. For large quantities, we use tailgate trucks for transportation to improve unloading efficiency.",
    },

    //组件农化
    "agrochemical": {
        "content1": "From the supply of plant protection products and original medicines to crop breeding and crop nutrition, we provide advanced logistics solutions for MAP modern agricultural technology service providers and intelligent agricultural service platforms to assistant Chinese agricultural modernization process.",
        "title1": "Seasonal Deployment",
        "content2": "To satisfy the seasonal characteristics of customer needs, we flexibly allocate capacity. Even in your busiest months of December to the following July, we can ensure you no worries about supply chain logistics.",
        "title2": "Remote Area Distribution",
        "content3": "Our strong logistics network ensures direct delivery to all RDC and remote areas nationwide."
    },

    //组件电子化学
    "electronicChemical": {
        "content1": "Aiming at the particularity of the electronic chemical material supply chain, we provide a full range of services, including chemical gas warehousing, standardized transportation services, import turnover container management, professional chemical import customs clearance, on-site operations, and consulting services, to eliminate the hidden worries about semiconductor raw material logistics.",
        "title1": "Chemical Gas Storage",
        "content2": "High-end warehouses combined with customized modifications, including temperature control, gas, and high-specification electronic chemical storage services. ",
        "title2": "Standardized Transportation Services",
        "content3": "For the packaging characteristics of electronic chemicals and gases, we provide additional services such as professional reinforcement, temperature control, and full-process supervision, also provide full-process visual management of route, speed, and temperature.",
        "title3": "Import Turnover Container Management",
        "content4": "We provide complete chain logistics services, including customs deposits, cylinder’s validity and tracking numbers, and export returns.",
        "title4": "Professional Chemicals Import Customs Clearance",
        "content5": "We manage the customs clearance process, prepare materials that meet professional regulatory standards in advance and conduct policy publicity and solution execution. ",
        "title5": "On-Site Operations",
        "content6": "We offer on-site outsourcing services for hazardous chemicals warehousing, including labor, systems, inventory design, and TCM services.",
        "title6": "Consulting Services",
        "content7": "We provide customers with customized consulting services and supply chain solutions with our domestic dangerous goods network and foreign site resources."
    },

    //组件新能源
    "newEnergy": {
        "content1": "As an essential link in the green supply chain for the recycling of power batteries for new energy vehicles, we have established a sizeable battery recycling network in the northern and eastern regions, providing professional services such as rack management, dangerous goods transportation, reverse logistics, network construction, packaging apparatus. When we receive a request from a car company to pick up the used battery, we send dangerous goods vehicles immediately to the 4S store for pickup; and then safely transport them to the waste recycling disposal factory designated by the new energy car company for subsequent power battery recycling, disassembly, and cascade utilization.",
        "title1": "Operation Model I",
        "content2": "We extract batteries from new energy battery manufacturers and send them to various OEMs, and provide battery racks for round-trip logistics between new energy battery manufacturers and various OEMs.",
        "title2": "Operation Model II",
        "content3": "Used batteries are picked up from 4S stores and stored in our warehouses. During that storage period, we also provide customers with various value-added services, for example, battery testing, battery discharging, repacking, replacing special packaging, to cooperate with subsequent transportation.",
        "title3": "Operation Model III",
        "content4": "In response to customer orders, we send used batteries to new energy battery recycling companies."
    },

    //组件化学试剂
    "chemicalReagent": {
        "content1": "Our nationwide networks are equipped with Class A dangerous goods warehouses, constant temperature, and refrigerated warehouses. Products cover chemical, testing, and biological reagents. The five central regional warehouses in East China, South China, North China, Central China, and Southwest China can be shipped simultaneously, ensuring same-day delivery of scientific service products in the core regions of 23 provinces nationwide and maximizing the shortening of logistics delivery time, to minimize the logistics and delivery time and ensures the timeliness of product delivery."
    },

    //组件HSSEQ体系建设里程碑
    "integrated": {
        "title1": ['ISO9001', 'ISO14001', 'OHSAS18001', 'RSQAS', 'ISO27001' , 'CRSAS'],
        "title2": ['The initial formation of the HSSEQ management system.', 'ISO 14001 environmental management system was established and implemented.', 'Based on quality management and features environmental safety management,the HSSEQ system has been preliminarily established.', 'Accredited by the Road Safety Quality Assessment System.','The introduction of a diversified management system comprehensively improves corporate management capability.','Passed the assessment of the CRSAS.']
    },

    //组件目标与宗旨
    "institutional": [
        {
            "title": "Leadershipand Full Participation",
            "content": ["Our top leaders actively engage in the HSSEQ management, take the scientific management of quality, environment, safety as the company's strategic goal and purpose, coordinate resources, and put it into practice.","Managers at all levels follow the overall strategy, serving and guaranteeing their operation process to ensure the overall goals are achieved.","All our employees actively participate in the operation process, aware of the benefits of implementing the system and otherwise possible adverse consequences."]
        },
        {
            "title": "Documentation System, Operating Guarantee",
            "content": ["Our company has formed a relatively complete document system after nearly 20 years of developing the HSSEQ management system. From groping and establishing per international standards to forming a document structure of the quality, environment, and safety management system in line with the company's operating characteristics, also, from the strategic policies issued by the top management to the operation protocol for the grassroots level, the HSSEQ management systems at all levels ensure each customer's service quality and safety."]
        },
        {
            "title": "Risk Awareness, Pre-management",
            "content": ['Preventive awareness is introduced into each operation process, and each risk point is identified and evaluated in plan formulation and process planning. Corresponding measures are formulated to eliminate adverse consequences in advance. We apply various methods to find hidden risks and adopt corresponding countermeasures to ensure customer requirements are met. For example, the internal review of the logistics service plan, the pre-operation review, the critical project road risk assessment, the pre-introduction review of new suppliers, the first operation assessment.','Through various channels, both employees and related parties can timely master occupational health and safety knowledge, on-site emergency response procedures, and basic hazard identification knowledge to enhance their health and safety prevention awareness.']
        },
        {
            "title": "PDCA, Continuous Optimization",
            "content": ["ISO 9001, ISO45001, and ISO14001 are the fundamental guarantees for the steady development of the company, which needs to be continuously improved and optimized in the course of operation in conjunction with the company's development strategy, goals, and service characteristics. Every department and project needs innovation and development awareness.From process to standardization to specialization, we never stop from meeting customer requirements to exceeding customer requirements."]
        }
    ],

    //组件数智化运用
    "responsibilityLanding": [
        {
            "title": "Warehouse Safety Inspection",
            "content": ['In the form of data-based terminals, standardized inspection rules for warehousing equipment hardware, personnel behavior, management software, we regularly and quantitatively conduct daily inspections, comprehensive Inspection, and hidden danger investigation on the operating site, effectively record to achieve the ultimate goal of improving warehouse safety management and reducing the occurrence of safety accidents.','Its use features are:  Eliminate the omission and absence of items in the inspection process. ','Uniform inspection standards and requirements.','Reflect the authenticity of the inspection.','With traceability.']
        },
        {
            "title": "Vehicle Inspection",
            "content": ["Take preventive Inspection of vehicle equipment as the basis for ensuring the essential safety of equipment, to achieve the purpose of providing the integrity of the vehicle's technical condition, ensuring driving safety, and saving the total cost of vehicle operation.",'Its use features are: Eliminate the perfunctory inspection and false records of operating personnel.','Real-time monitoring of the status and results of the inspection.','Avoid the defects of paper records such as tedious statistics and easy missing.','Guarantee the actual implementation and traceability of "three Inspections a day".']
        },
        {
            "title": "MSDS",
            "content": ['As most chemical manufacturers and importers, we follow MSDS (Material Safety Data Sheet) to clarify the physical and chemical properties of chemicals, such as PH, flash point, flammability, reactivity, and the possible health hazards to users, for instance, carcinogenic, teratogenic.','We compile the MSDS involved in the operation into a library, define the nature of the operation, filter and present the required content according to different needs of warehousing, transportation, and emergency handling. Also, we provide full-staff retrieval in the form of a cloud system. On each operation stage, different objects in the operation and emergency phases, their requirements for various fields of the MSDS can all be obtained.']
        },
        {
            "title": "NCM",
            "content": ['NCM（Non-conformance management）is one of the web-based digital tools for all employees to actively participate in quality and safety management. Through the timely feedback of non-conformance items found and occurred in warehousing, transportation production, and office area activities by all employees, it can be convenient.','In particular, we encourage front-line employees to find all kinds of hidden dangers. Once reported, relevant personnel will receive the information as soon as possible and promptly deal with it, including approval, regardless of personnel location. We encourage employees to report more and develop an awareness of attention to quality and safety proactively through the incentive mechanism. Through the big data, we analyze the implementation of the overall quality & safety, as well as the development trend of the company, find out the weaknesses, and improve in time.']
        }
    ],

    //组件个性化定制
    "contingency": [{
        "content": `For each customer project, we tailor the relevant SOP rules, KPI standards, and HSE requirements according to their nature and operational characteristics and realize "escorting logistics services" from point to point.`
    },{
        "content": "We elevate all chemical operations to the level of hazardous chemicals operations, self-pressurized, unified standards to strengthen management."
    },{
        "content": `Pay attention to the management of the cargo gateway. Before chemicals enter, hazardous transportation must be identified. Storage points, transportation requirements, operating procedures, environmental control, emergency handling, and other links must be formulated and implemented to ensure the controllability of the whole operation.`
    },{
        "content": `Effectively use the node monitoring and process tracking features of the "digital intelligence" software to control safety, quality, and environmental requirements throughout the entire process.`
    }],

    //组件特色展示
    "characteristicDisplay": [{
        "content": "Focus on details to ensure the smooth flow of the whole process, start small to drive the total radiation, and ultimately achieve the realization of the complete standardization."
    },{
        "content": "All staff participates in the hidden danger inspection to ensure there is no missing point."
    },{
        "content": "Firefighting layout at each point to realize the function of a miniature fire station."
    },{
        "content": "Managers lead inspections and records."
    },{
        "content": "Establish a whole responsibility system and guarantee that responsibility and compensation, responsibility and authority, and position and ability all correspond."
    },{
        "content": "Chemical Spill Drills"
    },{
        "content": "Fire Drill"
    }],

    //组件工作在嘉里
    "work": {
        "content1": "The key strength of Kerry Logistics Network remains its people. We are committed to creating value for our employees through rewarding careers, workplace quality and work-life balance.",
        "content2": "Our people are self-starters with can-do attitude and entrepreneurial spirit. We strive to be proactive in meeting customers’ needs, providing innovative solutions that help them fully realise their business goals. From frontline handlers to the top seat in the boardroom, we employ team approach, where respect for one another is a fundamental value.",
        "content3": "As we continue to grow and expand, we constantly invest in the development of our people, building a winning team by recruiting industry professionals and young talent from a diverse range of cultural backgrounds."
    },

    //组件集团新闻
    "groupNews": {
        "options": [{
            "label": "2022年",
            "value": "2022"
        },{
            "label": "2021年",
            "value": "2021"
        },{
            "label": "2020年",
            "value": "2020"
        }],
        "contents": [
            {
            "title": "2021-01-29 The Paper",
            "content1": "Kerry IMS Chemical Zhangjiagang Logistics Center Officially Lays the Foundation",
            "href": "https://m.thepaper.cn/baijiahao_10984124"
        },{
            "title": "2021-01-08 China Economic Net",
            "content1": "Kerry IMS Chemical Cangzhou Logistics Center Holds an Opening Ceremony Deepen the Layout of Chemical Logistics and Promote Regional Development",
            "href": "http://www.ce.cn/xwzx/gnsz/gdxw/202101/08/t20210108_36203550.shtml"
        },{
            "title": "2020-11-26 SINA Finance",
            "content1": "Kerry Logistics (00636) Extends Its Business Tentacles to Chemical Logistics Again after A nearly 1-fold Increase in 8 months",
            "href": "https://baijiahao.baidu.com/s?id=1684399993533696034&wfr=spider&for=pc"
        },{
            "title": "2020-11-20 China Economic Net",
            "content1": "Kerry Logistics Acquires 51% Stake in Tianjin Lanhai to Accelerate the Layout of Chemical Logistics",
            "href": "http://www.ce.cn/xwzx/gnsz/gdxw/202011/20/t20201120_36032888.shtml"
        },{
            "title": "2020-08-19 SOHU News",
            "content1": "Kerry IMS Chemical Logistics Holds Strategy Press Conference Deepens the Layout of Chemical Logistics",
            "href": "https://www.sohu.com/a/413826261_162522"
        },
        {
            "title": "2022-10-25",
            "content1": "【MEDIPARK Innovative service platform】KERRY IMS CHEMICAL: Escort the Logistics of Chemical Supply Chain",
            "href": "https://mp.weixin.qq.com/s/rz5BWo_BGGd0r5uIKeYbaQ"
        },{
            "title": "2022-08-18",
            "content1": "Kerry IMS Chemical Logistics Official Video Is Released",
            "href": "https://mp.weixin.qq.com/s/rlDr4rs3wtHUvK7FKOd33w"
        },{
            "title": "2022-08-09",
            "content1": "The Executive Vice Director And Secretary-general Zheng, Zai Leads A Team To Visit Kerry IMS Chemical Logistics, Focusing On The Construction And Upgrading Of The Shanghai International Shipping Center",
            "href": "https://mp.weixin.qq.com/s/NXQtuRyXWRtFZe2pC_eqcg"
        },{
            "title": "2022-08-04",
            "content1": "Kerry IMS Chemical Logistics Special Action To Against Summer Heat Waves For Safety Work",
            "href": "https://mp.weixin.qq.com/s/h7Llov3usm14f9wWwnqAFg"
        },{
            "title": "2022-06-02 Logclub",
            "content1": "Is KLN’s chemical logistics so strong?! SF Express has one more dominant card! ",
            "href": "https://mp.weixin.qq.com/s?__biz=MjM5NjAzMjM4MA%3D%3D&mid=2651193450&idx=1&sn=5aada097b2e6813af06247a2820e466a&scene=45#wechat_redirect"
        },{
            "title": "2022-05-18",
            "content1": "Zhangjiagang Chemical Logistics Project Officially Operation, Kerry Logistics Chemical Industry Circuit Layout Continues To Deepen",
            "href": "https://mp.weixin.qq.com/s/_7QD8oxixlVPK6LGWCwkbg"
        },{
            "title": "2022-05-16",
            "content1": "Kerry Lanhai (Tianjin) Logistics actively assists the resumption of production in Shanghai",
            "href": "https://mp.weixin.qq.com/s/R_ZBj_KsSribpSd7J2Vk_Q"
        },]
    },

    //组件嘉里物流联网
    "industryDynamics": {
        "options": [{
            "label": "2022年",
            "value": "2022"
        },{
            "label": "2021年",
            "value": "2021"
        },{
            "label": "2020年",
            "value": "2020"
        }],
        "contents": [
        {
            "title": "2022-08-01",
            "content1": "Kerry Logistics Network Ramps Up Own-controlled Network Service",
            "content2": "with Weekly Charter Flights from Hong Kong to Huntsville, USA",
            "href": "https://www.kln.com/en/press/press-release/2022/kerry-logistics-network-ramps-up-own-controlled-network-service-with-weekly-charter-flights-from-hong-kong-to-huntsville-usa/"
        },
        {
            "title": "2022-06-27",
            "content1": "Kerry Logistics Network’s Investor Relations Excellence",
            "content2": "Reaffirmed By Top Institutional Investor Rankings for the Seventh Year Running",
            "href": "https://www.kln.com/en/press/press-release/2022/kerry-logistics-network-s-investor-relations-excellence-reaffirmed-by-top-institutional-investor-rankings-for-the-seventh-year-running/"
        },
        {
            "title": "2022-05-11",
            "content1": "Kerry Logistics Network Pioneers as First Logistics Company to Use Electric Trucks in Hong Kong",
            "content2": "In a Move towards Net Zero Emissions",
            "href": "https://www.kln.com/en/press/press-release/2022/kerry-logistics-network-pioneers-as-first-logistics-company-to-use-electric-trucks-in-hong-kong-in-a-move-towards-net-zero-emissions/"
        },
        {
            "title": "2022-03-30",
            "content1": "Kerry Logistics Network Posts 102% Growth in Core Net Profit",
            "content2": "",
            "href": "https://www.kln.com/en/press/press-release/2022/kerry-logistics-network-posts-102-growth-in-core-net-profit/"
        },
        {
            "title": "2022-03-28",
            "content1": "Kerry Logistics Network Retains Outstanding Global 3PL Title",
            "content2": "Wins Quamnet Outstanding Enterprise Awards for the Seventh Consecutive Year",
            "href": "https://www.kln.com/en/press/press-release/2022/kerry-logistics-network-retains-outstanding-global-3pl-title-wins-quamnet-outstanding-enterprise-awards-for-the-seventh-consecutive-year/"
        },
        {
            "title": "2022-03-23",
            "content1": "Kerry Logistics Network Acquires Rehabilitation Equipment Supplier Pro-Med Technology",
            "content2": "To Strengthen Foothold in Medical Equipment Distribution in Hong Kong",
            "href": "https://www.kln.com/en/press/press-release/2022/kerry-logistics-network-acquires-rehabilitation-equipment-supplier-pro-med-technology-to-strengthen-foothold-in-medical-equipment-distribution-in-hong-kong/"
        },
        {
            "title": "2022-03-21",
            "content1": "Kerry Pharma Supports Local NGOs with Medication Home Delivery",
            "content2": "During Fifth Wave of COVID-19 Outbreak in Hong Kong",
            "href": "https://www.kln.com/en/press/press-release/2022/kerry-pharma-supports-local-ngos-with-medication-home-delivery-during-fifth-wave-of-covid-19-outbreak-in-hong-kong/"
        },
        {
            "title": "2022-02-25",
            "content1": "Kerry Logistics Network Named Excellent Logistics Enterprise",
            "content2": "At Top 100 Hong Kong Listed Companies Selection 2021",
            "href": "https://www.kln.com/en/press/press-release/2022/kerry-logistics-network-named-excellent-logistics-enterprise-at-top-100-hong-kong-listed-companies-selection-2021/"
        },
        {
            "title": "2022-02-15",
            "content1": "Kerry Logistics Network and Hengan Group’s Joint Venture Karrion",
            "content2": "Meets Strong Demand for COVID-19 Rapid Test Kits in Hong Kong",
            "href": "https://www.kln.com/en/press/press-release/2022/kerry-logistics-network-and-hengan-group-s-joint-venture-karrion-meets-strong-demand-for-covid-19-rapid-test-kits-in-hong-kong/"
        },
        {
            "title": "2022-01-21",
            "content1": "Kerry Logistics Network Wins Air Cargo Services Award",
            "content2": "At the British International Freight Association Freight Service Awards 2021",
            "href": "https://www.kln.com/en/press/press-release/2022/kerry-logistics-network-wins-air-cargo-services-award-at-the-british-international-freight-association-freight-service-awards-2021/"
        },
        {
            "title": "2021-12-17",
            "content1": "Kerry Logistics Network Wins Frost & Sullivan Asia-Pacific Best Practices Awards",
            "content2": "For the Fifth Consecutive Year",
            "href": "https://www.kln.com/en/press/press-release/2021/kerry-logistics-network-wins-frost-sullivan-asia-pacific-best-practices-awards-for-the-fifth-consecutive-year/"
        },
        {
            "title": "2021-12-13",
            "content1": "Kerry Logistics Network A Double Winner of The Asset ESG Corporate Awards",
            "content2": "2021 and IR Magazine’s Greater China Awards 2021",
            "href": "https://www.kln.com/en/press/press-release/2021/kerry-logistics-network-a-double-winner-of-the-asset-esg-corporate-awards-2021-and-ir-magazine-s-greater-china-awards-2021/"
        },
        {
            "title": "2021-11-16",
            "content1": "Well-recognised ESG Commitment from Kerry Logistics Network A Proud Winner of HKET and Bloomberg Businessweek ESG Awards",
            "href": "https://www.kln.com/en/press/press-release/2021/well-recognised-esg-commitment-from-kerry-logistics-network-a-proud-winner-of-hket-and-bloomberg-businessweek-esg-awards/"
        },{
            "title": "2021-11-11",
            "content1": "Kerry Logistics Network and My Jet Xpress Airlines Join Forces to Offer Customised Air Freight Options Within Asia",
            "href": "https://www.kln.com/en/press/press-release/2021/kerry-logistics-network-and-my-jet-xpress-airlines-join-forces-to-offer-customised-air-freight-options-within-asia/"
        },{
            "title": "2021-10-22",
            "content1": "Kerry Logistics Network Crowned Best 3PL Provider for the Sixth Time and Best Logistics Service Provider - Sea at AFLAS Awards",
            "href": "https://www.kln.com/en/press/press-release/2021/kerry-logistics-network-crowned-best-3pl-provider-for-the-sixth-time-and-best-logistics-service-provider-sea-at-aflas-awards/"
        },{
            "title": "2021-10-20",
            "content1": "Kerry Logistics Network and Hengan Group Form Joint Venture To Enhance Synergistic Competitiveness in Healthcare Products Market",
            "href": "https://www.kln.com/en/press/press-release/2021/kerry-logistics-network-and-hengan-group-form-joint-venture-to-enhance-synergistic-competitiveness-in-healthcare-products-market/"
        },{
            "title": "2021-10-18",
            "content1": "Kerry Logistics Network, the Proud Recipient of Grand Award At the 2021 Hong Kong Management Association Quality Award",
            "href": "https://www.kln.com/en/press/press-release/2021/kerry-logistics-network-the-proud-recipient-of-grand-award-at-the-2021-hong-kong-management-association-quality-award/"
        },
        // {
        //     "title": "2021-10-14 Shenzhen Evening News",
        //     "content1": "S.F. Holding acquires a 51.8% controlling stake in Kerry Logistics! Wang Wei becomes chairman of the board of Kerry Logistics",
        //     "href": "http://www.myzaker.com/article/616808261bc8e0f620000223"
        // },{
        //     "title": "2021-09-28 JIEMIAN",
        //     "content1": "S.F. completes the acquisition of a 51.8% stake in Kerry Logistics",
        //     "href": "http://www.jiemian.com/article/6651423.html"
        // },
        {
            "title": "2021-08-27",
            "content1": "Kerry Logistics Network Core Net Profit Up by 81%",
            "content2": "Profit Attributable to the Shareholders Up by 215%",
            "href": "https://www.kln.com/en/press/press-release/2021/kerry-logistics-network-core-net-profit-up-by-81-profit-attributable-to-the-shareholders-up-by-215/"
        },{
            "title": "2021-08-11",
            "content1": "Kerry Logistics Network Utilises KOOLBotic to Sort Chilled Products in F&B Operation",
            "href": "https://www.kln.com/en/press/press-release/2021/kerry-logistics-network-utilises-koolbotic-to-sort-chilled-products-in-f-b-operation/"
        },{
            "title": "2021-08-03",
            "content1": "Kerry Logistics Network Launches Own-Controlled Network",
            "content2": "to Link Asia to the Americas Hub",
            "href": "https://www.kln.com/en/press/press-release/2021/kerry-logistics-network-launches-own-controlled-network-to-link-asia-to-the-americas-hub/"
        },{
            "title": "2021-07-30",
            "content1": "Kerry Logistics Network Extends Coverage in Latin America with New Office in Peru",
            "href": "https://www.kln.com/en/press/press-release/2021/kerry-logistics-network-extends-coverage-in-latin-america-with-new-office-in-peru/"
        },{
            "title": "2021-07-02",
            "content1": "Kerry Logistics Network Secures Places Atop Institutional Investor Rankings",
            "content2": "Recognised As “Most Honored Companies” for the Sixth Consecutive Year",
            "href": "https://www.kln.com/en/press/press-release/2021/kerry-logistics-network-secures-places-atop-institutional-investor-rankings-recognised-as-most-honored-companies-for-the-sixth-consecutive-year/"
        },{
            "title": "2021-05-25",
            "content1": "MTR Corporation and Kerry eCommerce Join Hands to Launch “Kerry Express @ MTR Shops” New Retail Solution",
            "href": "https://www.kln.com/en/press/press-release/2021/mtr-corporation-and-kerry-ecommerce-join-hands-to-launch-kerry-express-mtr-shops-new-retail-solution/"
        },{
            "title": "2021-03-25",
            "content1": "Kerry Logistics Network Posts 30% Growth in Revenue",
            "content2": "Core Net Profit Increased by 33%",
            "href": "https://www.kln.com/en/press/press-release/2021/kerry-logistics-network-posts-30-growth-in-revenue-core-net-profit-increased-by-33/"
        },{
            "title": "2021-02-22",
            "content1": "Kerry Logistics Network Extends Winning Streak at the Quamnet Outstanding Enterprise Awards for Sixth Year Running",
            "href": "https://www.kln.com/en/press/press-release/2021/kerry-logistics-network-extends-winning-streak-at-the-quamnet-outstanding-enterprise-awards-for-sixth-year-running/"
        },{
            "title": "2021-02-10",
            "content1": "S.F. Holding and Kerry Logistics Network",
            "content2": "Announce Strategic Investment and Cooperation",
            "href": "https://www.kln.com/en/press/press-release/2021/s-f-holding-and-kerry-logistics-network-announce-strategic-investment-and-cooperation/"
        },{
            "title": "2021-01-15",
            "content1": "Kerry Logistics Network Opens Chemical Logistics Centre in Cangzhou China",
            "content2": "To Capture Market Potential in Chemical Logistics",
            "href": "https://www.kln.com/en/press/press-release/2021/kerry-logistics-network-opens-chemical-logistics-centre-in-cangzhou-china-to-capture-market-potential-in-chemical-logistics/"
        },{
            "title": "2020-12-24",
            "content1": "Kerry Logistics Network Completes Subsidiary Spin-off",
            "content2": "Kerry Express Thailand Debuts on the Stock Exchange of Thailand",
            "href": "https://www.kln.com/en/press/press-release/2020/kerry-logistics-network-completes-subsidiary-spin-off-kerry-express-thailand-debuts-on-the-stock-exchange-of-thailand/"
        },{
            "title": "2020-12-21",
            "content1": "Kerry Logistics Network Wins the Highest Honour The Asset Jade Award and",
            "content2": "The Best Investor Relations Team Award at The Asset ESG Corporate Awards 2020",
            "href": "https://www.kln.com/en/press/press-release/2020/kerry-logistics-network-wins-the-highest-honour-the-asset-jade-award-and-the-best-investor-relations-team-award-at-the-asset-esg-corporate-awards-2020/"
        },{
            "title": "2020-12-21",
            "content1": "Kerry Logistics Network Launches New Road Freight Products to Mongolia",
            "content2": "Offering Alternative Solutions to Explore Untapped Market Potential",
            "href": "https://www.kln.com/en/press/press-release/2020/kerry-logistics-network-launches-new-road-freight-products-to-mongolia/"
        },{
            "title": "2020-12-16",
            "content1": "Kerry Logistics Network to Develop 50,000 sq m Bonded Logistics Centre in Hainan FTP",
            "content2": "to Tap into the Growing Duty-free and Inbound e-Commerce Market",
            "href": "https://www.kln.com/en/press/press-release/2020/kerry-logistics-network-to-develop-50-000-sq-m-bonded-logistics-centre-in-hainan-free-trade-port/"
        },{
            "title": "2020-12-15",
            "content1": "Kerry Logistics Network Recognised at the Hong Kong Green Awards 2020",
            "content2": "As the Recipient of Corporate Green Governance Award - Corporate Leadership",
            "href": "https://www.kln.com/en/press/press-release/2020/kerry-logistics-network-recognised-at-the-hong-kong-green-awards-2020/"
        },{
            "title": "2020-12-11",
            "content1": "Kerry Logistics Clinches Titles at I.R. Magazine’s Greater China Awards 2020",
            "content2": "Winning Best in Sector: Industrials and Best Annual Report (Mid-cap)",
            "href": "https://www.kln.com/en/press/press-release/2020/kerry-logistics-network-clinches-titles-at-ir-magazine-s-greater-china-awards-2020/"
        },{
            "title": "2020-11-10",
            "content1": "Kerry Logistics Clinches AFLAS Awards Titles for the Fifth Time",
            "content2": "Winning Best 3PL Provider and Best Logistics Service Provider - Air Freight Honours",
            "href": "https://www.kln.com/en/press/press-release/2020/kerry-logistics-clinches-aflas-awards-titles-for-the-fifth-time-winning-best-3pl-provider-and-best-logistics-service-provider-air-freight-honours/"
        },{
            "title": "2020-11-02",
            "content1": "Kerry Logistics Network Honoured with Bloomberg Businessweek ESG Leading Enterprises Award for the Second Consecutive Year",
            "href": "https://www.kln.com/en/press/press-release/2020/kerry-logistics-network-honoured-with-bloomberg-businessweek-esg-leading-enterprises-award-for-the-second-consecutive-year/"
        },{
            "title": "2020-09-18",
            "content1": "Kerry Logistics Crowned the Winner of the CILT Award 2020 Enterprise Award for Service Excellence",
            "href": "https://www.kln.com/en/press/press-release/2020/%E5%98%89%E9%87%8C%E7%89%A9%E6%B5%81%E5%87%AD%E5%8D%93%E8%B6%8A%E6%9C%8D%E5%8A%A1%E8%8D%A3%E8%8E%B7%E8%BF%90%E8%BE%93%E7%89%A9%E6%B5%81%E5%8D%93%E8%B6%8A%E5%A4%A7%E5%A5%962020-%E4%BC%81%E4%B8%9A%E5%A4%A7%E5%A5%96/"
        },{
            "title": "2020-08-27",
            "content1": "Kerry Logistics Core Net Profit Up 26%",
            "content2": "IFF Segment Profit Increased by 40%",
            "href": "https://www.kln.com/en/press/press-release/2020/%E5%98%89%E9%87%8C%E7%89%A9%E6%B5%81%E6%A0%B8%E5%BF%83%E7%BA%AF%E5%88%A9%E6%8C%89%E5%B9%B4%E4%B8%8A%E5%8D%8726-%E5%9B%BD%E9%99%85%E8%B4%A7%E4%BB%A3%E4%B8%9A%E5%8A%A1%E5%88%86%E9%83%A8%E6%BA%A2%E5%88%A9%E5%BD%95%E5%BE%9740-%E5%A2%9E%E9%95%BF/"
        },{
            "title": "2020-08-26",
            "content1": "Kerry Logistics Network Scores Repeat Wins at the Frost & Sullivan Asia Pacific Best Practices Awards for the Fourth Year Running",
            "href": "https://www.kln.com/en/press/press-release/2020/%E5%98%89%E9%87%8C%E7%89%A9%E6%B5%81%E8%81%94%E7%BD%91%E8%BF%9E%E7%BB%AD%E7%AC%AC%E5%9B%9B%E5%B9%B4%E8%8D%A3%E8%86%BAfrost-sullivan%E4%BA%9A%E5%A4%AA%E5%8C%BA%E6%9C%80%E4%BD%B3%E5%AE%9E%E8%B7%B5%E5%A5%96/"
        },{
            "title": "2020-08-18",
            "content1": "Kerry Logistics Network’s Subsidiary Kerry Apex Ranked Number One NVOCC From Asia to the U.S. for the First Seven Months of 2020",
            "href": "https://www.kln.com/en/press/press-release/2020/%E5%98%89%E9%87%8C%E7%89%A9%E6%B5%81%E8%81%94%E7%BD%91%E6%97%97%E4%B8%8Bkerry-apex%E4%BA%8E2020%E5%B9%B4%E9%A6%96%E4%B8%83%E4%B8%AA%E6%9C%88-%E8%8D%A3%E7%99%BB%E4%BA%9A%E6%B4%B2%E8%87%B3%E7%BE%8E%E5%9B%BD%E7%AC%AC%E4%B8%80%E5%A4%A7%E6%97%A0%E8%88%B9%E6%89%BF%E8%BF%90%E5%95%86/"
        }
    ]
    },

    //组件愿景
    "vision": {
        "function": [{
            'title': "VISION",
            "content": "Devoted to becoming a professional leader in chemical logistics in Asia.",
        },{
            'title': "MISSION",
            "content": "Based in Asia, focusing on China, we provide distinguished logistics solutions and win profit for customers.",
        },{
            'title': "CORE VALUES – VOICE",
        },{
            'title': "Value Creation",
            "content": "We create real value for our clients, employees and shareholders through innovative solutions, rewarding careers and financial growth.",
        },{
            'title': "Openness",
            "content": "We believe in true openness and transparency throughout our company. Our management actively encourages open communication and dialogue at every level of the organisation."
        },{
            'title': "Integrity",
            "content": "Our business is built on integrity. We follow clear ethical guidelines and strictly enforce them throughout the company."
        },{
            'title': "Commitment",
            "content": "As a service provider we are committed to the success of our clients. We are fully dedicated to all projects and assignments we take on. We are also committed to our employees’ career development and to meeting shareholders’ expectations."
        },{
            'title': "Excellence",
            "content": "We believe in excellence and practise a continuous process of improvement and innovation."
        }]
    },

    //组件资质荣耀
    "glory": {
        "content1": "We have a long-standing commitment to the quality of global service. Through constant cooperation with long-term progress, we provide customers with the optimal supply chain solutions & competitive cost management. ",
        // "content2": "通过与客户的长期合作和持续改进,我们为客户提供最佳的供应链解决方案和具有竞争力的成本管理。",
        "content3": "We have won numerous awards over the years and are approved by all parties.",
        "card": ["CRSAS", "IEC27001","IEC27001","ISO45001","ISO14001","ISO9001","FROM BASF","FROM AKZONOBEL","FROM BP","FROM JOHNSON CONTROLS","FROM EASTMAN","Superior Logistics Supplier  From Swancor Advanced Materials","Outstanding Contribution Award From Jotun","Distinguished Contribution Award From Corteva","VP Unit Of DG Chemicals Association Of CFLP","MSDS SOFTWARE COPYRIGHT CERTIFICATE","VEHICLE INSPECTION SOFTWARE COPYRIGHT CERTIFICATE","NCM SOFTWARE COPYRIGHT CERTIFICATE","2020 China Best Practice Enterprise in Safety Management Of DG Chemical Logistics","CERTIFICATE OF WORK SAFETY STANDARDIZATION OF TRANSPORTATION ENTERPRISES","SEMI","Safety Management Award Of China Chemical Logistics Industry","2021 SCITECH AND INNOVATION PROJECT OF CHEMICAL LOGISTICS OPERATION MODEL"]
    },

    // 组件企业社会责任
    "responsibility": [{
        "year": "2021",
        "title": "SUSTAINABILITY REPORT",
        "url": "https://www.kln.com/media/c1ep3mqo/esg-2021-c.pdf"
    },
        {
        "year": "2020",
        "title": "SUSTAINABILITY REPORT",
        "url": "https://www.kln.com/media/bkekridc/esg-2020-c.pdf"
    },{
        "year": "2019",
        "title": "ESG REPORT",
        "url": "https://www.kln.com/media/fs2jjggy/esg-2019_c.pdf"
    },{
        "year": "2018",
        "title": "ESG REPORT",
        "url": "https://www.kln.com/media/r4tl5noo/esg-2018_c.pdf"
    },{
        "year": "2017",
        "title": "ESG REPORT",
        "url": "https://www.kln.com/media/jbxltumi/esg-2017_c.pdf"
    },{
        "year": "2016",
        "title": "ESG REPORT",
        "url": "kln.com/media/csvd4w31/esg-2016_c.pdf"
    },{
        "year": "2015",
        "title": "CSR REPORT",
        "url": "https://www.kln.com/media/4chjaoct/esg-2015_c.pdf"
    },{
        "year": "2014",
        "title": "CSR REPORT",
        "url": "https://www.kln.com/media/fvff4wnx/esg-2014_c.pdf"
    },{
        "year": "2013",
        "title": "CSR REPORT",
        "url": "https://www.kln.com/media/5qultt5e/esg-2013_c.pdf"
    }],

    //组件联系我们
    "contact": {
        "title": "CONTACTS",
        "company": "Kerry IMS Chemical Logistics Co., Ltd.",
        "address": "388, Shengrong Road, Building 23, Pudong New District, Shanghai, China",
        "phone": "021-51386111",
        "post": "021-51386111",
        "mail": "presiden.office@kerryhcl.com",
        "fax": '201210',
        "url": 'www.kerryims.com',
    },

    //组件合作伙伴
    "partner": {   
    },

    //组件仓储信息可视化
    "storageVisualization": {
        "content": "Our solution department works with the IT department to 'deconstruct' the warehousing operations and analyze them in detail. Then, in the specific operation process, the investment in the procedure, personnel, and technology can improve and change the existing operation's safety, standardization, and efficiency and have future replication and promotion.",
        "content2": "For example, we use different devices such as OCR identification, RFID, Voice Picking in different on-site warehouses to improve efficiency."    
    },
    //组件远程信息可视化
    "transportationVisualization": {
        "content": "With our digital intelligent management platform, the entire transportation process can be grasped in real-time, whether in the central monitoring room or client-side."
    },
    //组件msds云系统&运输车辆安全检查
    "independentlySoftware": {
        "content": "Our series of self-developed HSSEQ intelligent management software provides timely, accurate, and reliable HSSEQ information for decision-makers through a unified, shared, and efficient digital intelligent management platform.",
        "content1": "For different logistics operators, MSDS files can be quickly obtained at any time, realize cloud storage, and mobile terminals can access them so that the data can be stored and inquired; that is, what is checked is what is needed.",
        "content2": "According to the regulatory requirements of the Shanghai Vehicle Transportation Management Center and Road Safety Association, and other supervisory departments, we carry out vehicle safety inspections before, during, and after transportation, covering owned vehicles and outsourcing vehicles. The system uses mobile terminal equipment to check the system time and geographical location, significantly reducing the false security check.",
        "content3": "It is applied to warehouse safety inspections, including daily and weekly inspections for warehouse managers. Inspection items include warehouse area and equipment check. In addition, the system uses mobile terminal equipment to check the system time and geographical location, significantly reducing the false security check and improving the safety of warehouse operations. It can also be used for multiple warehouses across the country, covering warehouse area and equipment inspection, and the safety inspection of dangerous goods vehicles entering the park.",
        "content4": "Following 'GB 13861 Classification And Code For The Hazardous And Harmful Factors In Process', we conduct reason analysis for daily operation, including recording, analysis, tracking, and publication of non-conformities. It helps identify the root cause and avoid repetition and facilitate the scientific study of the incident by the relevant persons and management personnel, to formulate preventive measures in a targeted manner in the future.",
        "content5": "Our IT system has already realized EDI docking with many customers, which can conduct the functions of order docking, customer files, product files, storage, storage, transfer, inventory difference report."
    },
    //组件工作机会
    "workChance": {
        "content": "We truly believe in our people – as skilled employees, supportive team members and uniquely talented individuals.To join us,Please click below for details.",
        "title1": "工作内容:", 
        "title2": "任职要求:",
        "title3": "工作地点:",
        "title4": "简历请投递至:",
        "positionList": [{
            "position": "电子化学品物流经理",
            "jobContent": ['根据公司战略目标,完成公司计划制定对客户需求收集成本并能制作方案;','熟悉危险品操作流程、国内运输、仓储或进出口空海运;','负责开拓电子化学品客户,日常客户关系维护;','调查、跟踪、分析客户需求,及时有效地提供客户服务;','跟进客户合同谈判、签署,公司内部审核流程;','负责项目的应收应付账款的正常回收支付。'],
            "jobRequirement": ['5年以上相关工作经验,具有一定供应链项目经验,大专以上学历','有半导体原物料物流行业经验,有半导体、电子化学品物流经验或者客户','良好的沟通协调能力、组织计划能力、学习应用能力及适应环境能力','熟练运用办公软件,擅长PPT制作及Excel数据分析。'],
            "workAddress": "上海市浦东新区盛荣路388弄23号",
            "mail": "hr.dept@kerryims.com"
        },{
            "position": "物流销售经理",
            "jobContent": ['负责公司化工物流业务的市场拓展和项目开发工作;','负责对当地及周边地区的化工企业、化工园区的市场调研和物流需求分析,并建立与园区、企业之间的沟通合作关系;','负责获取并参与化工客户的物流招标活动及标书准备工作;','负责根据客户要求制作业务报价和完成合同流程;','负责收集和分析当地竞争对手的信息和动态;','负责了解所在地区的化工专业操作资源信息;','完成公司规定的销售工作报告、报表及系统操作等内部管理工作。'],
            "jobRequirement": ['有1年以上国内物流行业销售经验,有强烈的客户开发和销售意向;','有化工物流行业销售经验优先考虑;','具有较强的开拓与沟通能力,能承受压力,品行端正。'],
            "workAddress": "上海市浦东新区盛荣路388弄23号",
            "mail": "hr.dept@kerryims.com"
        },{
            "position": "仓库经理",
            "jobContent": ['处理项目仓储运营管理与咨询项目的日常运营,包括货物的进货,出货,储存,退货,盘点,订单处理,客户服务,仓库管理和配送管理系统的运营;','确保该项目严格按照标准运营流程（SOP）和质量标准（KPI）高效运营;','带领团队,对该项目实施PDCA改进计划,不断提高运营效率,降低运营成本;','负责该项目的人员和团队建设和管理;','安全管理：确保该项目的货物,人员,财产,信息和公司形象的安全;','客户管理：确保客户的满意度达到99%。'],
            "jobRequirement": ['有丰富的仓储管理经验,熟练掌握仓库和配送管理系统;','极强的团队管理和现场作业管理能力;','有一定的文字和PPT功底。'],
            "workAddress": "上海市浦东新区盛荣路388弄23号",
            "mail": "hr.dept@kerryims.com"
        },{
            "position": "仓储管培生",
            "jobContent": ['文档的整理、书写;','相关仓库现场清点、数据分析;','物流相关系统操作;','编写PPT报告、提交月度实习报告;','日常会议纪要记录。'],
            "jobRequirement": ['有很强的表达能力和学习能力,愿意接受外派及出差。'],
            "workAddress": "上海市浦东新区盛荣路388弄23号",
            "mail": "hr.dept@kerryims.com"
        },{
            "position": "财务主管",
            "jobContent": ['了解公司财务管理,包括预算管理、核算管理等;','负责加强公司资金管理,保证企业运营所需资金的正常运转;','对公司税收进行整体筹划,加强公司经济管理,提高经济效益;','建立健全公司财务管理、会计核算、预算等相关制度,保障公司合法经营,维护公司权益;','负责统筹组织公司财务预算、会计核算、财务报告等,定期检查、监督、跟进预算执行的情况,及时做出调整与控制;','了解公司财务状况、经营成果和资金变动情况,及时提供真实的会计核算资料,组织经营分析报告,为公司决策提供依据。'],
            "jobRequirement": ['5年以上财务工作经验,其中3年以上总账会计经验;','具备初级会计职称;','熟悉各种财务系统及软件。'],
            "workAddress": "上海市浦东新区盛荣路388弄23号",
            "mail": "hr.dept@kerryims.com"
        }]
    }
}

export default zh;



// WEBPACK FOOTER //
// ./src/assets/languages/en.js